import { PlanboardState } from '@reducers/v2/planboard/types';
import {
  DEMO_MACHINE_ID,
  LEGACY_DEMO_MACHINE_ID,
  DEMO_ID_THRESHOLD,
} from '../../../../components/tours/config/planboard/constants';

export const clearDemoOperationsAction = (state: PlanboardState) => {
  // Remove demo machine columns (both new and legacy IDs)
  delete state.machineProductionOperations[DEMO_MACHINE_ID];
  delete state.machineProductionOperations[LEGACY_DEMO_MACHINE_ID];

  // Clear demo items from No Machine column
  // Remove items with IDs >= DEMO_ID_THRESHOLD (new) or negative IDs (legacy)
  const noMachine = state.machineProductionOperations[-1];
  if (noMachine) {
    noMachine.items = noMachine.items.filter(
      (item) => item.productionOperationId > 0 && item.productionOperationId < DEMO_ID_THRESHOLD
    );
    noMachine.total = noMachine.items.length;
  }
};
